(async () => {
    class VariantSelects extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("change", this.onVariantChange);
            this.isFeelstars = this.dataset.productType === "FeelStars" ? true : false;
        }

        onVariantChange() {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, "", false);

            if (!this.currentVariant) {
                this.toggleAddButton(true, "", true);
                this.setUnavailable();
            } else {
                // this.updateMedia();
                this.updateURL();
                this.updateVariantInput();
                this.toggleElements();
                this.renderProductInfo();
                this.dispatchVariantChange();
            }
        }

        updateOptions() {
            this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
        }

        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant) => {
                return !variant.options
                    .map((option, index) => {
                        return this.options[index] === option;
                    })
                    .includes(false);
            });
        }

        dispatchVariantChange() {
            document.dispatchEvent(
                new CustomEvent("variant-change", {
                    bubbles: true,
                    variant: this.currentVariant,
                    detail: {
                        variant: this.currentVariant,
                    },
                }),
            );
        }

        dispatchVariantChanged() {
            document.dispatchEvent(
                new CustomEvent("variant-changed", {
                    bubbles: true,
                    detail: {
                        variant: this.currentVariant,
                    },
                }),
            );
        }

        updateMedia() {
            if (!this.currentVariant || !this.currentVariant?.featured_media) return;
            const newMedia = document.querySelector(
                `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
            );
            if (!newMedia) return;
            const parent = newMedia.parentElement;
            parent.prepend(newMedia);
            window.setTimeout(() => {
                parent.scroll(0, 0);
            });
        }

        updateURL() {
            if (!this.currentVariant) return;
            window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateVariantInput() {
            const productForms = document.querySelectorAll(
                `#product-form-${this.dataset.section}, #product-form-installment`,
            );
            productForms.forEach((productForm) => {
                const input = productForm.querySelector('input[name="id"]');
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        toggleElements(hide = true) {
            const priceDesktop = document.getElementById(`price-${this.dataset.section}`);
            const priceMobile = document.getElementById(`price-mobile-${this.dataset.section}`);
            if (hide) {
                priceDesktop?.classList.add("element-opacity");
                priceMobile?.classList.add("element-opacity");
            } else {
                priceDesktop?.classList.remove("element-opacity");
                priceMobile?.classList.remove("element-opacity");
            }
        }

        renderProductInfo() {
            fetch(
                `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
            )
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, "text/html");
                    const sourcePrice = html.getElementById(`price-${this.dataset.section}`);
                    const priceDesktop = document.getElementById(`price-${this.dataset.section}`);
                    const priceMobile = document.getElementById(`price-mobile-${this.dataset.section}`);
                    const priceStickyATC = document.getElementById(`sticky-atc-${this.dataset.section}`);

                    // update the title
                    if (this.isFeelstars) {
                        const title = document.getElementById(`title-${this.dataset.section}`);
                        title.innerHTML = this.currentVariant.title;
                    }

                    // update the prices
                    if (sourcePrice && priceDesktop) priceDesktop.innerHTML = sourcePrice.innerHTML;
                    if (sourcePrice && priceMobile) priceMobile.innerHTML = sourcePrice.innerHTML;
                    if (sourcePrice && priceStickyATC) priceStickyATC.innerHTML = sourcePrice.innerHTML;

                    document.querySelector("sticky-add-to-cart")?.classList.remove("hidden");
                    priceDesktop?.classList.remove("hidden");
                    priceMobile?.classList.remove("hidden");
                    priceMobile?.nextElementSibling.classList.remove("is-col-2");

                    // update the collapsibles
                    const sourceCollapsibles = html.querySelectorAll("[data-product-collapsible-wrapper]");
                    const collapsibles = document.querySelectorAll("[data-product-collapsible-wrapper]");
                    if (collapsibles.length > 0) {
                        collapsibles.forEach((collapsible) => collapsible.remove());
                    }
                    if (sourceCollapsibles.length > 0) {
                        sourceCollapsibles.forEach((collapsible) => {
                            // Hack to insert collapsibles before Yot-Po review app. (remove this check if the app gets uninstalled)
                            const yotPo = document.querySelector(".yotpo.yotpo-main-widget")?.parentNode;

                            if (yotPo) {
                                yotPo.before(collapsible);
                            } else {
                                if(document.querySelector("product-info").querySelector('.sticky') != null) {
                                    document.querySelector("product-info").querySelector('.sticky').append(collapsible)
                                } else {
                                    document.querySelector("product-info").append(collapsible)
                                }
                            }
                        });
                    }

                    // update the button
                    if (this.currentVariant) {
                        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
                    }

                    // Update the inventory quantity hidden input
                    const inventoryQtyDestination = document
                        .querySelector(`#product-form-${this.dataset.section}`)
                        .querySelector('input[name="inventory_quantity"]');
                    const inventoryQtySource = html
                        .querySelector(`#product-form-${this.dataset.section}`)
                        .querySelector('input[name="inventory_quantity"]');
                    inventoryQtyDestination.value = inventoryQtySource.value;
                })
                .then(() => {
                    this.toggleElements(false);
                    this.dispatchVariantChanged();
                });
        }

        toggleAddButton(disable = true, text, modifyClass = true) {
            const addButton = document
                .getElementById(`product-form-${this.dataset.section}`)
                ?.querySelector('[name="add"]');

            if (!addButton) return;

            if (disable) {
                addButton.setAttribute("disabled", true);
                if (text) addButton.textContent = text;
            } else {
                addButton.removeAttribute("disabled");
                addButton.textContent = window.variantStrings.addToCart;
            }

            if (!modifyClass) return;
        }

        setUnavailable() {
            const addButton = document
                .getElementById(`product-form-${this.dataset.section}`)
                ?.querySelector('[name="add"]');
            if (!addButton) return;
            addButton.textContent = window.variantStrings.unavailable;
            document.getElementById(`price-${this.dataset.section}`)?.classList.add("hidden");
        }

        getVariantData() {
            this.variantData =
                this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
            return this.variantData;
        }
    }

    if (!customElements.get("variant-selects")) {
        customElements.define("variant-selects", VariantSelects);
    }

    class VariantRadios extends VariantSelects {
        constructor() {
            super();
        }

        updateOptions() {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));
            this.options = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
            });
        }
    }

    if (!customElements.get("variant-radios")) {
        customElements.define("variant-radios", VariantRadios);
    }



    if (!customElements.get("variant-images")) {
        const {
            default: Swiper,
            Navigation,
            Scrollbar
        } = await import("swiper");
        Swiper.use([Navigation, Scrollbar]);

        class VariantImages extends VariantRadios {
            constructor() {
                super();

                if (!Swiper) {
                    return false;
                }

                this.swiperElement = this.querySelector("[data-swiper-variant]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 3,
                    observer: true,
                    resizeEvent: "auto",
                    breakpoints: {
                        320: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        1440: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()

            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
            }
        }

        customElements.define("variant-images", VariantImages);
    }
})();
